// src/pages/treatments/Orthodontics.jsx
import { Link } from 'react-router-dom';
import OrthodonticsT8 from '../../Assets/images/OrthodonticsT8.png'
import OB from '../../Assets/images/Orthodontics.jpg'
const Orthodontics = () => {
  return (
    <main className="pt-20 md:pt-24 min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative h-80 md:h-[500px] flex items-center justify-center bg-blue-50">
        <div className="absolute inset-0">
          <img
            src={OrthodonticsT8}
            alt="Orthodontics"
            className="w-full h-full object-cover brightness-75"
          />
          {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />
        </div>
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 tracking-tight">
            Orthodontics
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-light">
            Straighten your smile with expert orthodontics
          </p>
        </div>
      </section>

      {/* Breadcrumb */}
      {/* <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-6 py-4 flex flex-wrap items-center text-sm text-gray-600">
          <Link to="/" className="hover:text-blue-600 transition">Home</Link>
          <span className="mx-2">›</span>
          <Link to="/treatments" className="hover:text-blue-600 transition">Treatments</Link>
          <span className="mx-2">›</span>
          <span className="text-blue-600 font-medium">Orthodontics</span>
        </div>
      </div> */}

      {/* Main Content – Flex Layout */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
            {/* Image Section */}
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src={OB}
                alt="Orthodontics Procedure"
                className="w-full max-w-md rounded-2xl shadow-xl object-cover"
              />
            </div>

            {/* Text Content */}
            <div className="w-full lg:w-1/2 flex flex-col">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Best Orthodontists in Hyderabad
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                This dental care involves giving a better appearance of the teeth either by moving or straightening the crooked teeth. This dental procedure gives the teeth a healthy life for a long time while giving a better look to the teeth. This usually involves dental x-rays and making a mould of the shape of your teeth to come up with a prosthetic known as “braces”. The treatment depends on the severity of the problem and can take anything from a few months to two-and-a-half years.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                At SRIDHAR DENTAL we are experienced in fitting a modern range of cosmetic orthodontic braces, lingual orthodontics, and invisible braces for creating straight teeth and beautiful smiles for both adult and child orthodontic treatment.
              </p>

              {/* Benefits – Flex wrap */}
              <div className="flex flex-wrap gap-6 mb-10">
                <div className="flex-1 min-w-[200px] p-4 bg-blue-50 rounded-lg shadow-md">
                  <h4 className="font-bold text-lg mb-2">Crooked, crowded, and protruding teeth</h4>
                </div>
                <div className="flex-1 min-w-[200px] p-4 bg-blue-50 rounded-lg shadow-md">
                  <h4 className="font-bold text-lg mb-2">Gapped teeth-large or uneven space between teeth</h4>
                </div>
                <div className="flex-1 min-w-[200px] p-4 bg-blue-50 rounded-lg shadow-md">
                  <h4 className="font-bold text-lg mb-2">Extra or missing teeth</h4>
                </div>
                <div className="flex-1 min-w-[200px] p-4 bg-blue-50 rounded-lg shadow-md">
                  <h4 className="font-bold text-lg mb-2">Irregularities of the jaws.</h4>
                </div>
                <div className="flex-1 min-w-[200px] p-4 bg-blue-50 rounded-lg shadow-md">
                  <h4 className="font-bold text-lg mb-2">Cleft palate</h4>
                </div>
                <div className="flex-1 min-w-[200px] p-4 bg-blue-50 rounded-lg shadow-md">
                  <h4 className="font-bold text-lg mb-2">Rotation</h4>
                </div>
              </div>

              {/* CTA */}
              <div className="flex justify-start">
                <Link to="/book-appointment" className="bg-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition">
                  Book Appointment
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Orthodontics;